export default (props?: any) => {
    let webiId = undefined;
    let webiTitle = undefined;
    const webiClasses = [];

    if (typeof (props.webiType) !== "undefined" && props.webiType !== "") {
        if (props.webiType !== "webi-link") {
            webiClasses.push("webi-link");
        }

        webiClasses.push(props.webiType);

        webiId = props.webiIdentifier;
        webiTitle = props.webiTitle;
    }

    return [webiId, webiClasses, webiTitle];
};